import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
interface CreateUserModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CreateUserModal({
  isOpen,
  onClose
}: CreateUserModalProps) {
  const {
    workspaces,
    roles,
    createUser
  } = useWorkspace();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    workspaceId: workspaces[0]?.id || '',
    roleId: roles.find(r => r.name === 'Team User')?.id || roles[0]?.id || 1,
    role: 'Team User' as const
  });
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const selectedRole = roles.find(r => r.id === formData.roleId);
    createUser({
      ...formData,
      role: (selectedRole?.name || 'Team User') as any
    });
    onClose();
    setFormData({
      name: '',
      email: '',
      workspaceId: workspaces[0]?.id || '',
      roleId: roles.find(r => r.name === 'Team User')?.id || roles[0]?.id || 1,
      role: 'Team User'
    });
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-191">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-192">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} data-id="element-193" />

        <div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:w-full sm:max-w-lg" data-id="element-194">
          <div className="px-4 py-5 sm:p-6" data-id="element-195">
            <div className="flex items-center justify-between mb-5" data-id="element-196">
              <h3 className="text-lg font-medium leading-6 text-gray-900" data-id="element-197">
                Create New User
              </h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-198">
                <X className="h-6 w-6" data-id="element-199" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-200">
              <div data-id="element-201">
                <label className="block text-sm font-medium text-gray-700" data-id="element-202">
                  Full Name
                </label>
                <input type="text" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} data-id="element-203" />
              </div>

              <div data-id="element-204">
                <label className="block text-sm font-medium text-gray-700" data-id="element-205">
                  Email Address
                </label>
                <input type="email" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-206" />
              </div>

              <div data-id="element-207">
                <label className="block text-sm font-medium text-gray-700" data-id="element-208">
                  Workspace
                </label>
                <select className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formData.workspaceId} onChange={e => setFormData({
                ...formData,
                workspaceId: e.target.value
              })} data-id="element-209">
                  {workspaces.map(ws => <option key={ws.id} value={ws.id} data-id="element-210">
                      {ws.name}
                    </option>)}
                </select>
              </div>

              <div data-id="element-211">
                <label className="block text-sm font-medium text-gray-700" data-id="element-212">
                  Role
                </label>
                <select className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formData.roleId} onChange={e => setFormData({
                ...formData,
                roleId: parseInt(e.target.value)
              })} data-id="element-213">
                  {roles.map(role => <option key={role.id} value={role.id} data-id="element-214">
                      {role.name} - {role.description}
                    </option>)}
                </select>
                <p className="mt-1 text-xs text-gray-500" data-id="element-215">
                  {roles.find(r => r.id === formData.roleId)?.permissions.length || 0}{' '}
                  permissions
                </p>
              </div>

              <div className="mt-5 sm:mt-6" data-id="element-216">
                <button type="submit" className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm" data-id="element-217">
                  Create User
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
}